import script from "./text.vue?vue&type=script&setup=true&lang=ts"
export * from "./text.vue?vue&type=script&setup=true&lang=ts"

import "./text.vue?vue&type=style&index=0&id=153dc517&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-153dc517"]])

export default __exports__